import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { environment } from './../../../../../environments/environment';
import { of } from 'rxjs/observable/of';

@Injectable()
export class SiteDetailService {

  private urlPrefix: string = environment.appUrl;

  constructor(
    private http: HttpClient
  ) { }

  getDetail(id): Observable<any> {
    const url = this.urlPrefix + 'sites/' + id;
    return this.http
      .get(url, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }


  getRecordSheet(siteId): Observable<any> {
    const url = this.urlPrefix + `sites/recordSheet/${siteId}`;
    return this.http
      .get(url, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }


  getEquipmentLayoutPlans(siteId): Observable<any> {
    return this.http.get(environment.appUrl + 'sites/' + siteId +'/equipment-layout-plans', {observe: 'body', withCredentials: true});
  }

  deleteEquipmentLayoutPlan(planId): Observable<any> {
    return of('');
  }
  addRecordSheet(siteId, description): Observable<any> {
    const url = this.urlPrefix + `sites/recordSheet/create/${siteId}`;
    return this.http
      .post(url, { description}, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }
  downloadEquipmentLayoutPlan(itemId): Observable<any> {
    const url = this.urlPrefix + `media/download`;
    return this.http.post(url, {fileIds: [itemId]}, {
      observe: 'response',
      responseType: 'blob'
    })
    .map(res => {
      if (res.status === 200) {
        return {
          file: res.body,
          fileName: res.headers.get('content-disposition').replace('attachment;filename=', '')
        };
      } else {
        return Observable.throw(null);
      }
    })
    .catch(err => {
      return Observable.throw(err);
    });
  }
  deletePlan(siteId, itemId): Observable<any> {
    return this.http.put(environment.appUrl + 'sites/' + siteId +'/equipment-layout-plans/'+itemId+'/delete', {} , {observe: 'body', withCredentials: true});
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/site/site-detail/site-detail.service.ts